<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Nome" v-model="current.groupname" outlined dense></v-text-field>
            </div>
            <div class="col-md-9 col-sm-1">
              <v-text-field label="Descrição" v-model="current.details" outlined dense></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()" v-if="$auth.check('ROLE_ADMIN')">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <div class="row">
      <div class="col-md-6 col-sm-1">
        <v-card>
          <v-card-title>Checagens</v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Atributo</th>
                  <th>Operação</th>
                  <th>Valor</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in checkList" :key="item.id">
                  <td>{{ item.attribute }}</td>
                  <td>{{ item.op }}</td>
                  <td>{{ item.value }}</td>
                  <td>
                    <v-btn small color="error" @click="removeCheck(item.id)" v-if="$auth.check('ROLE_ADMIN')">x</v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <div>
              <v-btn color="primary" @click="dialog_check = true" v-if="$auth.check('ROLE_ADMIN')">adicionar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
      <div class="col-md-6 col-sm-1">
        <v-card>
          <v-card-title>Respostas</v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Atributo</th>
                  <th>Operação</th>
                  <th>Valor</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in replyList" :key="item.id">
                  <td>{{ item.attribute }}</td>
                  <td>{{ item.op }}</td>
                  <td>{{ item.value }}</td>
                  <td>
                    <v-btn small color="error" @click="removeReply(item.id)" v-if="$auth.check('ROLE_ADMIN')">x</v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <div>
              <v-btn color="primary" @click="dialog_reply = true" v-if="$auth.check('ROLE_ADMIN')">adicionar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="dialog_check" max-width="360">
      <v-card>
        <v-card-title class="headline">Nova checagem do grupo</v-card-title>
        <v-card-text>
          <v-text-field label="Atributo" v-model="attr.attribute" outlined dense></v-text-field>
          <v-text-field label="Operação" v-model="attr.op" outlined dense></v-text-field>
          <v-text-field label="Valor" v-model="attr.value" outlined dense></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary"  @click="addCheck()">Salvar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success"  @click="dialog_check = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_reply" max-width="360">
      <v-card>
        <v-card-title class="headline">Nova resposta do grupo</v-card-title>
        <v-card-text>
          <v-text-field label="Atributo" v-model="attr.attribute" outlined dense></v-text-field>
          <v-text-field label="Operação" v-model="attr.op" outlined dense></v-text-field>
          <v-text-field label="Valor" v-model="attr.value" outlined dense></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary"  @click="addReply()">Salvar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success"  @click="dialog_reply = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    attr: {attribute:"",op:"",value:""},
    checkList: null,
    replyList: null,
    dialog_check: false,
    dialog_reply: false,
  }),
  created: function () {
    this.load();
    this.loadCheck();
    this.loadReply();
  },
  methods: {
    addCheck: function(){
      var me = this;
      this.dialog_check = false;
      var obj = {};
      obj.id = 0;
      obj.attribute = this.attr.attribute;
      obj.op = this.attr.op;
      obj.value = this.attr.value;
      obj.groupname = this.current.groupname;
      var token = localStorage.getItem("token");
      console.log(obj);
      api
          .post("/radgroupcheck", obj, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            me.loadCheck();
          });
      this.attr = {attribute:"",op:"",value:""};
    },
    removeCheck: function(id){
      var me = this;
      var token = localStorage.getItem("token");
      api
          .delete("/radgroupcheck/"+id, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            me.loadCheck();
          });
    },
    loadCheck: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/radgroupcheck" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.checkList = response.data;
        })
        .catch(function () {
          console.log("radgroupcheck fail");
        });
    },
    addReply: function(){
      var me = this;
      this.dialog_reply = false;
      var obj = {};
      obj.id = 0;
      obj.attribute = this.attr.attribute;
      obj.op = this.attr.op;
      obj.value = this.attr.value;
      obj.groupname = this.current.groupname;
      var token = localStorage.getItem("token");
      console.log(obj);
      api
          .post("/radgroupreply", obj, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            me.loadReply();
          });
      this.attr = {attribute:"",op:"",value:""};
    },
    removeReply: function(id){
      var me = this;
      var token = localStorage.getItem("token");
      api
          .delete("/radgroupreply/"+id, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            me.loadReply();
          });
    },
    loadReply: function(){
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/radgroupreply" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.replyList = response.data;
        })
        .catch(function () {
          console.log("radgroupreply fail");
        });
    },
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/radgroup" + "/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
        })
        .catch(function () {
          console.log("radgroup fail");
        });
    },
    save: function () {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/radgroup", this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Grupo cadastrado com sucesso!");
            router.push({ path: "/radgroup" });
          });
      } else {
        api
          .put("/radgroup/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Grupo atualizado com sucesso!");
            router.push({ path: "/radgroup" });
          });
      }
    },
  },
};
</script>